import { render } from "./ruleadd.vue?vue&type=template&id=65d98625"
import script from "./ruleadd.vue?vue&type=script&lang=js"
export * from "./ruleadd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__